var $ = window.$;

$(function() {
  window.TES = window.TES || {};
  var $favouritesLink = $('.js-favourites');
  var $favouriteError = $('.js-favourties-error');
  var resourceId = $favouritesLink.data('resourceid');
  var user = window.TES.user;
  var isFavourited = null;

  if ($favouritesLink.length === 0 || !resourceId) {
    return;
  }

  // close event to hide error message
  $favouriteError.find('span.glyphicon').click(function() {
    $favouriteError.fadeOut();
  });

  if (user.isAuthenticated()) {
    // Get if resource is favourited
    $.ajax({
      type: 'GET',
      dataType: 'json',
      headers: {'x-csrf-token': window.Cookies.get('csrf')},
      url: '/api/favourites/v1/' + resourceId,
      success: function(response) {
        isFavourited = response.isFavourite;
        $favouritesLink.toggleClass('isActive', isFavourited);
      },
      error: function() {
        $favouritesLink.removeClass('isActive');
      },
    });
  }

  // onClick handler for fav link
  $favouritesLink.click(function(e) {
    if (user.isAuthenticated()) {
      e.preventDefault();
      // Ajax call
      $.ajax({
        type: 'POST',
        dataType: 'json',
        headers: {'x-csrf-token': window.Cookies.get('csrf')},
        data: { applicationId: resourceId },
        url: '/api/favourites/v1/' + (isFavourited ? 'remove' : ''),
        success: function(response) {
          // hide the error
          $favouriteError.fadeOut();
          // change the status of the link based on the response
          isFavourited = response.isFavourite;
          $favouritesLink.toggleClass('isActive', isFavourited).blur();
        },
        error: function() {
          $favouriteError.hide().removeClass('hide').fadeIn();
        },
      });
    }
  });
});
